<template>
  <div class="site">
    <SiteHeader />
    <main>
      <HeroSection />
      <PackagesSection />
      <section class="section" style="padding-top: 0; padding-bottom: 0">
        <div class="journey">
          <p class="eyebrow">{{ $t("journey.eyebrow") }}</p>
          <h2>{{ $t("journey.title") }}</h2>
          <p>{{ $t("journey.lead") }}</p>
        </div>
      </section>
      <ServicesSection />
      <ExtraServicesSection />
      <SubscriptionSection />
      <StatsSection />
      <AboutSection />
      <FaqSection />
      <SeoKnowledgeSection />
      <ContactSection />
    </main>
    <SiteFooter />
    <WhatsAppFloat />
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import AboutSection from "@/components/site/AboutSection.vue";
import ContactSection from "@/components/site/ContactSection.vue";
import ExtraServicesSection from "@/components/site/ExtraServicesSection.vue";
import FaqSection from "@/components/site/FaqSection.vue";
import HeroSection from "@/components/site/HeroSection.vue";
import PackagesSection from "@/components/site/PackagesSection.vue";
import SeoKnowledgeSection from "@/components/site/SeoKnowledgeSection.vue";
import ServicesSection from "@/components/site/ServicesSection.vue";
import SiteFooter from "@/components/site/SiteFooter.vue";
import SiteHeader from "@/components/site/SiteHeader.vue";
import StatsSection from "@/components/site/StatsSection.vue";
import SubscriptionSection from "@/components/site/SubscriptionSection.vue";
import WhatsAppFloat from "@/components/site/WhatsAppFloat.vue";

export default {
  name: "HomeView",
  components: {
    SiteHeader,
    HeroSection,
    PackagesSection,
    ServicesSection,
    ExtraServicesSection,
    SubscriptionSection,
    StatsSection,
    AboutSection,
    FaqSection,
    SeoKnowledgeSection,
    ContactSection,
    SiteFooter,
    WhatsAppFloat,
  },
  setup() {
    const route = useRoute();
    onMounted(() => {
      const sectionMap = {
        "/paketler": "#paketler",
        "/kurumsal-web": "#paketler",
        "/eticaret": "#paketler",
        "/crm": "#paketler",
        "/b2b": "#paketler",
        "/mobil-uygulama": "#paketler",
        "/sanal-pos": "#paketler",
        "/muhasebe-entegrasyonu": "#paketler",
        "/alotech": "#hizmetler",
        "/etkinlik-biletleme": "#hizmetler",
        "/ozel-erp": "#hizmetler",
        "/abonelik": "#abonelik",
        "/hizmetler": "#hizmetler",
        "/hakkimizda": "#hakkimizda",
        "/sss": "#sss",
        "/rehber": "#rehber",
        "/iletisim": "#iletisim",
      };
      const target = route.hash || sectionMap[route.path];
      if (target) {
        setTimeout(() => {
          const el = document.querySelector(target);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 350);
      }
    });
  },
};
</script>
